module.exports = __webpack_public_path__ + "static/media/page_14.325e0d37.jpg";